import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import ControlledTextField from "../../../components/ControlledTextField";
import { Form } from "react-bootstrap";
import { CardText, CardTitle, Container } from "reactstrap";
import { toast } from "react-toastify";
import logo from "../../../assets/icons/logo1.PNG";
import GoogleIcon from "../../../assets/icons/google-icon.PNG";
import "firebase/auth";
import "./index.css";
import {
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  signInWithPopup,
} from "firebase/auth";
import { auth, generateToken } from "../../../firebase";
import { useLazyGetExistingUserInfoQuery } from "../../../redux/services/getUserService";
import GoogleSignUpData from "../SignUp/GoogleSignUpData";
import { useCreateCustomerMutation } from "../../../redux/services/customerCreateService";
import { useLazyGetCustomerProfileQuery } from "../../../redux/services/getCustomer";
import { useAddMessageTokenMutation } from "../../../redux/services/userService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { setCustomer } from "../../../redux/customerSlice";
import { validateProfilePhotoUrl } from "../../../utility/Utility";

type FormData = {
  email: string;
  password: string;
};

interface SignInModalProps {
  setModalOpen: any;
  setIsSignInModalOpen: any;
}

const SignInModal: React.FC<SignInModalProps> = ({
  setModalOpen,
  setIsSignInModalOpen,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [userData, setUserData] = useState<any>({
    displayName: "",
    email: "",
    phoneNumber: "",
    photoUrl: "",
  });

  const [isDataModalOpen, setIsDataModalOpen] = useState<boolean>(false);

  const [triggerGetUserInfo] = useLazyGetExistingUserInfoQuery();

  const [
    addMessageToken
  ] = useAddMessageTokenMutation();

  const [createCustomer] = useCreateCustomerMutation();

  const { control, handleSubmit } = useForm<FormData>({
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const [triggerGetCustomerInfo] = useLazyGetCustomerProfileQuery();

  const GetCustomerData = async (accessToken: string) => {
    const response = await triggerGetCustomerInfo(accessToken);
    if (response.data?.id) {
      localStorage.setItem("customerId", response.data.id);
    }
    sendMessageToken();
  };

  const sendMessageToken = async () => {
    const token = await generateToken();
    if (token) {
      const newCustomerId = localStorage.getItem("customerId") || "";
      if (newCustomerId !== "") {
        await addMessageToken({
          token,
          userType: "WebCustomer",
          customerId: newCustomerId,
        });
      }
    }
  };

  const handleSignIn = async (data: FormData) => {
    const { email, password } = data;
    if (!email || !password) {
      toast.error("Please enter your email and password.");
      return;
    }
    setIsLoading(true);
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const accessToken = await userCredential.user.getIdToken();

      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("isUserSignIN", "true");
      localStorage.setItem("email", userCredential.user.email || "");
      localStorage.setItem("photoURL", userCredential.user.photoURL || "");
      localStorage.setItem("ownerID", userCredential.user.uid);

      const response = await triggerGetUserInfo(accessToken);

      if (response?.data?.userRoles?.includes("customer")) {
        toast.dismiss();
        toast.success("Welcome Back! You've Logged In Successfully!");
        
        dispatch(setCustomer({
          id: response.data.userId,
          userId: response.data.userId,
          displayName: response.data.displayName || '',
          email: response.data.email || '',
          phoneNumber: response.data.phoneNumber || '',
          isAnonymousUser: false,
          photoUrl: validateProfilePhotoUrl(response.data.photoUrl)
        }));
      } else {

        const userDataObj: any = {
          userId: response?.data?.userId,
          displayName: response?.data?.displayName,
          email: response?.data?.email,
          phoneNumber: response?.data?.phoneNumber,
          photoUrl: response?.data?.photoUrl
        };

        await createCustomer(
          userDataObj
        ).unwrap();
        toast.dismiss();
        toast.success("Welcome ! You've Logged In As Customer Successfully!");

        dispatch(setCustomer({
          id: response?.data?.userId,
          userId: response?.data?.userId,
          displayName: response?.data?.displayName || '',
          email: response?.data?.email || '',
          phoneNumber: response?.data?.phoneNumber || '',
          isAnonymousUser: false,
          photoUrl: userCredential.user.photoURL,
          settings: {
            requiresOrderVerification: false
          },
          addresses: []
        }));
      }
      GetCustomerData(accessToken);
      setModalOpen(false);
      navigate("/");

    } catch (error: any) {
      toast.error(error.message || "Invalid email or password.");
    } finally {
      setIsLoading(false);
    }
  };


  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({
      prompt: "select_account",
    });

    try {

      const userCredential = await signInWithPopup(auth, provider);
      toast.success("Google Sign-In Successful!");
      const accessToken = await userCredential.user.getIdToken();
      localStorage.setItem("accessToken", accessToken);

      if (userCredential.user.uid) {
        localStorage.setItem("ownerID", userCredential.user.uid);
      }
      if (userCredential.user.email) {
        localStorage.setItem("email", userCredential.user.email);
      }
      if (userCredential.user.photoURL) {
        localStorage.setItem("photoURL", userCredential.user.photoURL);
      }

      const response = await triggerGetUserInfo(accessToken);

      if (response?.data?.userRoles?.includes("customer")) {
        toast.success("Welcome back!");
        dispatch(setCustomer({
          id: response.data.userId,
          userId: response.data.userId,
          displayName: response.data.displayName || userCredential.user.displayName || '',
          email: response.data.email || userCredential.user.email || '',
          phoneNumber: response.data.phoneNumber || '',
          isAnonymousUser: false,
          photoUrl: userCredential.user.photoURL 
          // Add other fields from response if available
        }));
        setModalOpen(false);
        GetCustomerData(accessToken);
      } else {
        toast.info("New user detected, please complete signup.");
        setIsDataModalOpen(true);
        const userDataObj: any = {
          userId: userCredential.user.uid,
          displayName: userCredential.user.displayName || "New User",
          email: userCredential.user.email,
          phoneNumber: userCredential.user.phoneNumber,
          photoUrl:
            userCredential.user.photoURL ,
        };

        setUserData(userDataObj);
        setIsDataModalOpen(true);
        dispatch(setCustomer({
          id: userCredential.user.uid,
          userId: userCredential.user.uid,
          displayName: userCredential.user.displayName || "New User",
          email: userCredential.user.email || '',
          phoneNumber: userCredential.user.phoneNumber || '',
          isAnonymousUser: false,
          photoUrl: userCredential.user.photoURL,
          settings: {
            requiresOrderVerification: false
          },
          addresses: []
        }));
      }

      localStorage.setItem("isUserSignIN", "true");
      navigate("/");

    } catch (error: any) {
      console.error("Error signing in with Google: ", error);
      toast.error(error.message || "Failed to sign in with Google.");
    }
  };

  const onSubmit = (data: FormData) => {
    handleSignIn(data);
  };

  return (
    <div>
      <Container
        fluid
        className="d-flex align-items-center justify-content-center"
      >
        <div
          className="p-4 card-signin text-center"
          style={{ maxWidth: "450px" }}
        >
          <div className="mb-1">
            <img
              src={logo}
              alt="loginimage"
              style={{ width: "200px", marginRight: "10px" }}
            />
          </div>
          {isDataModalOpen ? (
            <GoogleSignUpData
              userData={userData}
              setUserData={setUserData}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              setIsDataModalOpen={setIsDataModalOpen}
              setModalOpen={setModalOpen}
            />
          ) : (
            <>
              <CardTitle tag="h2" className="fw-bold text-light mb-1">
                Welcome to Curry King !
              </CardTitle>
              <CardText className="mb-1 text-light">
                Please sign in to your account and start the adventure.
              </CardText>
              <div className="auth-login-form mt-1">
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <div className="mb-3">
                    <ControlledTextField
                      label={""}
                      inputName={"email"}
                      inputType={"email"}
                      placeholder={"Enter Your Email"}
                      isRequired={true}
                      control={control}
                    />
                  </div>
                  <div className="mb-3">
                    <ControlledTextField
                      label={""}
                      inputName="password"
                      inputType="password"
                      placeholder="Enter Password"
                      isRequired={true}
                      control={control}
                    />
                  </div>

                  <div className="d-grid">
                    <button
                      type="submit"
                      className="btn my-2 py-2 btn-signin-color btn-block"
                      disabled={isLoading}
                    >
                      {isLoading ? (<><FontAwesomeIcon icon={faSpinner} spin className="me-2" />Signing In...</>) : "Sign In"}
                    </button>
                  </div>

                  <div className="text-center text-light mt-3">
                    <p>
                      No account? Please{" "}
                      <div
                        className="btn mx-2 text-link-color"
                        onClick={() => {
                          setIsSignInModalOpen(false);
                        }}
                      >
                        SignUp
                      </div>
                    </p>
                  </div>
                </Form>
                <div className="d-grid mt-3">
                  <button
                    className="btn text-link-color d-flex align-items-center justify-content-center"
                    onClick={handleGoogleSignIn}
                  >
                    <img
                      src={GoogleIcon}
                      alt="Google Icon"
                      style={{ width: "20px", marginRight: "10px" }}
                    />
                    Sign In with Google
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </Container>
    </div>
  );
};

export default SignInModal;
